import { MIXED_METHODOLGY_PROJECTS } from '@/api/rest/resources/conservation';
import { METHODOLOGY_EXPLAINER_PAGE_BU, METHODOLOGY_EXPLAINER_PAGE_VNU } from '@/config/constants';

import { useProject } from './useProject';

export const useMethodologyPageLink = () => {
  const project = useProject();

  if (project?.id && MIXED_METHODOLGY_PROJECTS.includes(project.id as (typeof MIXED_METHODOLGY_PROJECTS)[number])) {
    return METHODOLOGY_EXPLAINER_PAGE_VNU;
  }

  return project?.natureUnitVariant === 'vnu' ? METHODOLOGY_EXPLAINER_PAGE_VNU : METHODOLOGY_EXPLAINER_PAGE_BU;
};
